import axios from 'axios';
import React, { useEffect, useState } from 'react';

export default function CountArrearsEngineeringFirms() {
  const [arrearsEngineeringFirms, setArrearsEngineeringFirms] = useState([]);

  //Count total number of members in arrears
  useEffect(() => {
    const fetchArrearsEngineeringFirms = async () => {
      try {
        const res = await axios.get(
          'https://databasebackend.ecz.co.zw/engineeringfirms/arrearsmembers'
        );
        setArrearsEngineeringFirms(res.data[0].arrearsEngineeringFirms);
      } catch (err) {
        console.log(err);
      }
    };
    fetchArrearsEngineeringFirms();
  }, []);

  return <>{arrearsEngineeringFirms}</>;
}
